import { Injectable, Type } from '@angular/core';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

/**
 * Drop-in replacement for PrimeNG's DialogService.
 *
 * Since PrimeNG 21 the DynamicDialog passes the raw `config.closable` (which is
 * `undefined` when callers don't set it) down to the inner <p-dialog>, where
 * `booleanAttribute(undefined)` coerces it to `false` and the close (X) button is
 * never rendered. This restores the previous behaviour by defaulting `closable`
 * to `true` for every `open()` call, while still honouring an explicit
 * `closable: false`.
 */
@Injectable()
export class AppDialogService extends DialogService {
  override open<T, DataType = any, InputValuesType extends Record<string, any> = {}>(
    componentType: Type<T>,
    config: DynamicDialogConfig<DataType, InputValuesType>,
  ): DynamicDialogRef<T> | null {
    if (config && config.closable === undefined) {
      config = { ...config, closable: true };
    }
    return super.open(componentType, config);
  }
}
